<template>
  <div class="wrap JobAddress">
    <el-row :gutter="30">
      <el-col
        class="wow animate__slideInUp"
        :data-wow-delay="`${idx / 10}s`"
        :xs="24"
        :sm="24"
        :md="8"
        :key="idx"
        v-for="(item, idx) in contactList" v-show="item.IsShow"
      >
        <div class="itemJob">
          <i class="el-icon-location-outline"></i>
          <h3>{{ item.Name }}</h3>

          <div
            class="item"
            :key="subIdx"
            v-for="(subItem, subIdx) in item.ContactInfos"
          >
            {{ subItem }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="pageBox" v-if="showPage">
      <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/views/components/Pagenation";
import { WOW } from "wowjs";

export default {
  data() {
    return {
      contactList: [],
      PagingInfo: {},
      showPage:false
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.$api
      .contact({
        Type: 2,
      })
      .then((res) => {
        const { CompanyInfos,PagingInfo } = res.Value;
        this.contactList = CompanyInfos;
        this.PagingInfo = PagingInfo;
        if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
        this.$nextTick(() => {
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            live: false,
          }).init();
        });
      });
  },
};
</script>

<style lang="scss">
</style>